<template>
    <div class="meetings-listings">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="text-muted">Profile</p>
                    <h2 class="listing-title d-inline-block mb-0">Meeting</h2>
                </b-col>
                <b-col cols="6" class="text-right">
                    <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button>
                    <b-button variant="primary" class="btn-header" disabled hidden>Schedule</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card no-body>
                  <b-tabs>
                    <b-tab active>
                        <template #title>
                            <span slot="label"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 448 512"><path fill="currentColor" d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h352v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg> Calendar View</span>
                        </template>
                        <meeting-calendar></meeting-calendar>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span slot="label"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-80c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"/></svg> List View</span>
                        </template>
                        <meeting-listing-table></meeting-listing-table>
                    </b-tab>
                </b-tabs>
            </b-card>
            
        </b-container>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import MeetingListingTable from '@/views/Meeting/MeetingListingTable'
import MeetingCalendar from '@/views/Meeting/MeetingCalendar'

export default {
    components: {
        MeetingListingTable,
        MeetingCalendar,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            backButton: false,
        }
    },
    created() {
        if(this.$route.params.token)
        {
            this.backButton = true;
        }
    },
    methods: {
        close() {
            if(this.$route.params.token)
            {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else
            {
                this.$router.back();
            }
        },
    }
}
</script>